module.exports = __webpack_public_path__ + "media/images/locations/sm/austerlia-7a1ceb2c29de4c26de8bf33f399c6653.jpg";